import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import ROUTES from '../../../constants/routes';
import PageTitle from '../../../components/UI/PageTitle/PageTitle';
import NewLoader from '../../../components/NewLoader/NewLoader';
import PromotersPromoterNavTabs from '../../../components/NavigationTabs/PromotersPromoterNavTabs';
import { getPromoter } from '../../../store/actions/promotersActions';

import PromotersPromoterInfo from './PromotersPromoterInfo/PromotersPromoterInfo';
import PromotersPromoterMaps from './PromotersPromoterMaps/PromotersPromoterMaps';

import './PromotersPromoter.sass';

const PromotersPromoter = ({ user, loading, currentPromoter, getPromoter, match }) => {
  useEffect(() => {
    const { promoterId } = match.params;
    
    getPromoter(user.token, promoterId)
  }, []);

  return (
    <section className='promoters-promoter promoter'>
      <div className='promoters-promoter__wrapper'>
        <div className='promoters-promoter__nav'>
          <PromotersPromoterNavTabs />
        </div>

        <div className='promoters-promoter__container'>
          {loading && (
            <div className='promoters-promoter__loader'>
            <NewLoader />
          </div>
          )}
          <div className='promoters-promoter__title'>
            <PageTitle>
              {currentPromoter.name}
            </PageTitle>
          </div>

          <Switch>
            <Redirect
              from={ROUTES.PROMOTERS_PROMOTER}
              to={ROUTES.PROMOTERS_PROMOTER_INFO}
              exact
            />

            <Route path={ROUTES.PROMOTERS_PROMOTER_INFO} exact component={PromotersPromoterInfo} />
            <Route path={ROUTES.PROMOTERS_PROMOTER_MAPS} exact component={PromotersPromoterMaps} />
          </Switch>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = ({
  auth: { user },
  promoters: { loading, currentPromoter }
}) => ({ user, loading, currentPromoter });

const mapDispatchToProps = (dispatch) => ({
  getPromoter: (token, id) => dispatch(getPromoter(token, id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PromotersPromoter));
